// Affiliate portal API client (#612). Cookie-session auth (set by the magic
// link) — no JWT/corebyscott; just same-origin credentials.
async function req(path, options = {}) {
  const res = await fetch(`/portal${path}`, {
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.error || 'Request failed');
    err.status = res.status;
    throw err;
  }
  return res.status === 204 ? null : res.json();
}

export const portalApi = {
  me: () => req('/me'),
  links: () => req('/links'),
  earnings: () => req('/earnings'),
  requestLink: (email) => req('/auth/request_link', { method: 'POST', body: JSON.stringify({ email }) }),
  signup: (name, email) => req('/auth/signup', { method: 'POST', body: JSON.stringify({ name, email }) }),
  signOut: () => req('/auth/sign_out', { method: 'DELETE' }),
};
